import { render, staticRenderFns } from "./languageListForm.vue?vue&type=template&id=56fcd322&scoped=true&"
import script from "./languageListForm.vue?vue&type=script&lang=js&"
export * from "./languageListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fcd322",
  null
  
)

export default component.exports